import React, { useEffect, useState } from 'react';
import logo from '../../img/onlymelogo.png';

interface LoadingSpinnerProps {
  isPending: boolean;
  /**
   * 로딩 스피너가 표시되기까지의 최소 지연 시간 (ms)
   * @default 500
   */
  delay?: number;
  /**
   * 로딩 스피너가 한번 표시되면 최소한 보여줄 시간 (ms)
   * @default 1000
   */
  minShowDuration?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ isPending, delay = 500, minShowDuration = 1000 }) => {
  const [shouldShow, setShouldShow] = useState(false);
  const [showStartTime, setShowStartTime] = useState<number | null>(null);

  useEffect(() => {
    let delayTimeoutId: NodeJS.Timeout;
    let minDurationTimeoutId: NodeJS.Timeout;

    if (isPending) {
      delayTimeoutId = setTimeout(() => {
        setShouldShow(true);
        setShowStartTime(Date.now());
      }, delay);
    } else if (showStartTime) {
      // 이미 스피너가 표시되고 있는 경우
      const elapsedTime = Date.now() - showStartTime;
      const remainingTime = Math.max(0, minShowDuration - elapsedTime);

      minDurationTimeoutId = setTimeout(() => {
        setShouldShow(false);
        setShowStartTime(null);
      }, remainingTime);
    } else {
      // 아직 스피너가 표시되지 않은 경우 (delay 시간 내에 완료)
      setShouldShow(false);
      setShowStartTime(null);
    }

    return () => {
      if (delayTimeoutId) {
        clearTimeout(delayTimeoutId);
      }
      if (minDurationTimeoutId) {
        clearTimeout(minDurationTimeoutId);
      }
    };
  }, [isPending, delay, minShowDuration, showStartTime]);

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 animate-fade-in">
      <style>
        {`
          @keyframes fill-up {
            0% {
              transform: translateY(100%);
            }
            100% {
              transform: translateY(0%);
            }
          }
          .animate-fill-up {
            animation: fill-up 1.5s ease-in-out infinite alternate;
          }
        `}
      </style>
      {/* 로고를 담을 컨테이너 */}
      <div className="relative w-20" style={{ height: '7.5rem' }}>
        {/* 회색 배경 로고 */}
        <img src={logo} alt="Loading background" className="absolute inset-0 w-full h-full opacity-20" />
        {/* 채워지는 효과를 위한 컨테이너 */}
        <div className="absolute bottom-0 left-0 w-full h-full overflow-hidden">
          <div className="absolute bottom-0 left-0 w-full h-full animate-fill-up">
            {/* 채워지는 녹색 로고 */}
            <img src={logo} alt="Loading foreground" className="w-full h-auto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
